import React, { useState, useEffect, useRef } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import axios from 'axios';

function Regen({amount, apikey, contract, bg, size, blings}) {
    const canvasRef = useRef(null);
    const canvas = canvasRef.current;
    let x = 0, y = 0;

    const [tokenId, setTokenId] = useState('');
    const [imageURL, setImageURL] = useState('');
    const [plainImage, setPlainImage] = useState('');
    const [bling, setBling] = useState(false);
    const [error, setError] = useState('');
    const [selectedOptions, setSelectedOptions] = useState('');
    const [savedTraits, setSavedTraits] = useState('');
    
    const regExp = /^0[0-9].*$/;

    // OPTION SELECTED
    const handleOptionClick = (option) => {
      setSelectedOptions(option);

      canvas.getContext('2d').clearRect(x, y, size, size);
      fetchImage(plainImage, 1, 0);
      
      rerunFetchImage(imageURL,option);
    };

    const rerunFetchImage = (newImage, option) => {
      let selected_trait = savedTraits.find(trait => trait.trait_type === option.trait_type);

      let blingbling;
      if (option.trait_type) {
        
        if (selected_trait) {
          if(typeof option.sex === 'string') {
            blingbling = require(`./images/bling/${option.imageName}_${selected_trait.trait_type_clean}.png`);
          } else {
            if(option.sex == true) {
              blingbling = require(`./images/bling/${option.imageName}_${selected_trait.trait_type_clean}.png`);
            } else {
              blingbling = require(`./images/bling/${option.imageName}_${option.trait_type}_${selected_trait.value}.png`);
            }
          }
        } else {
          console.log('No matching trait found');
          return;
        }
      } else {
        blingbling = require(`./images/bling/${option.imageName}.png`);
      }

      if (blingbling !== null) {
        fetchImage(blingbling, 2, 1);
      }
    } // fetch image

    // GET IMAGE
    let fetchImage = (source, total, current) => {
      return new Promise(resolve => {

        let image = new Image();
        image.src = source;
        image.onload = () => {
          canvas.getContext('2d').globalAlpha = 1;
          canvas.getContext('2d').drawImage(image, x, y, size, size);
          resolve();
        }  
        image.setAttribute('crossorigin', 'anonymous');

        setTimeout(() => {
          setImageURL(image);
        }, 500)
      });
    }

    // SUBMIT
    const handleSubmit = async (e) => {
      e.preventDefault();

      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(x, y, size, size);

      if(tokenId === '') {
          setError('ID cannot be blank');
          setBling(false);
      } else if(regExp.test(tokenId) == true) {
          setError('Remove the 0 at the beginning');
          setBling(false);
      } else if(tokenId > amount) {
          setError('Choose an ID between 1 and '+amount);
          setBling(false);
      } else {
        // GOOD TO GOOOOOO
        try {
          const osApiKey = apikey;
          const osContract = contract;
                
          const axiosConfig = {
            method: 'GET',
            headers: {accept: 'application/json', 'X-API-KEY': `${osApiKey}`}
          }

          const response = await axios.get(`https://api.opensea.io/v2/chain/base/contract/${osContract}/nfts/${tokenId}`, axiosConfig);
          
          let data = response.data;
          let imageURL  = data.nft.image_url;
          let image_resized = imageURL.replace('w=500', 'w=' + size);

          setImageURL(image_resized)
          setPlainImage(image_resized)

          fetchImage(image_resized, 1, 0)
          
          setBling(true);
          
          if (data.nft && data.nft.traits) {
            const traitsArray = data.nft.traits.map((trait) => ({
              trait_type: trait.trait_type === "artist" ? "type" : trait.trait_type.replace(/^_/, ''),
              trait_type_clean: trait.trait_type,
              value: trait.trait_type === "artist" ? "custom" : trait.value.replace(/:/g, '')
            }));
            setSavedTraits(traitsArray);
          } else {
            console.error('Traits not found in the data object');
          }

          setError('');
        } catch (err) {
          console.log(err);
          setImageURL('');
          setError('Error fetching image. Please check the token ID.');
        }
      }
    };

    // DOWNLOAD
    const downloadAsset = () => {
        const dataURL = canvasRef.current.toDataURL('image/png');
        const a = document.createElement('a');
        a.href = dataURL;
        a.download = 'download.png';

        a.click();
    }

    return (
        <div className="gm-wrapper">
          <Header />
          <div className="gm">

            <div className="download-left">

              <div 
                className="inner top">
                <form id="download-form" name="download-form" onSubmit={handleSubmit}>
                  <h2>Enter Your Token ID</h2>
                  <div className="field number">
                    <input
                      name="theid" 
                      id="theid" 
                      placeholder="Token ID" 
                      pattern="\d{1,4}" 
                      maxLength="4"
                      value={tokenId}
                      onChange={(e) => setTokenId(e.target.value)}
                    />
                  <button className="btn" type="submit"><span>Generate Image</span></button>
                  </div>{/* FIELD */}
                  {error && <p className="throw_error">{error}</p>}
                </form>{/* FORM */}
                </div>{/* INNER */}

                {imageURL && (
                  <div className="inner bottom">
                    <h2>ADD BLING TO YOUR RE:GEN</h2>

                    <div className="options">
                      {blings
                        .filter((bling) => {
                          if (typeof bling.sex === 'string') {
                            return savedTraits.some(trait => trait.trait_type_clean === bling.sex);
                          }
                          return true;
                        })
                        .map((bling) => {
                          const imagePath = require(`./images/bling/${bling.imageName}.gif`);
                          return (
                                                          <div
                                key={bling.id}
                                className={`bling ${
                                  selectedOptions.id === bling.id
                                    ? 'selected'
                                    : ''
                                }`}
                                trait_type={bling.trait_type}
                                imagename={bling.imageName}
                                onClick={() => handleOptionClick(bling)}
                              >
                              <div className="img-wrap"><img src={imagePath} alt={bling.name} /></div>
                              <p>{bling.name}</p>
                            </div>
                          );
                        })}
                    </div>
                </div>
                )}
            </div>{/* LEFT */}

            <div className="canvas-outter-wrap">
              <div id="canvas-wrap">
                  <canvas
                    ref={canvasRef}
                    id="imageCanvas"
                    width={size}
                    height={size}
                    style={{backgroundImage: `url(${bg})`}}
                  ></canvas>
                {imageURL && (
                  <>
                  <img
                    crossOrigin="anonymous"
                    src={imageURL}
                    alt="Token"
                    style={{ display: 'none' }}
                  />
                  </>
                )}
              </div>{/* CANVAS WRAP */}
                {imageURL && (
                  <button 
                    className="download btn"
                    onClick={downloadAsset}
                  >Download Image</button>
                )}
            </div>

          </div>{/* GM */}

          <Footer />
        </div>
    )
}

export default Regen;